import lang from '../../../lang/index.js';
export default function email({ isOrganizationEmail } = { isOrganizationEmail: false }) {
    /* eslint-disable */
    return this.matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, lang().validation.email(isOrganizationEmail));
    /* eslint-enable */
}
//# sourceMappingURL=index.js.map